import ctl from '@netlify/classnames-template-literals'
import { ReactNode } from 'react'

export type FilterBoxTheme = 'default' | 'floating'

export type FilterBoxProps = {
	children: ReactNode
	icon?: ReactNode
	theme?: FilterBoxTheme
	className?: string
}

const themeStyles: Record<FilterBoxTheme, string> = {
	default: 'bg-white ring ring-grey-200 rounded-md flex items-center pl-0 focus-within:ring-blue-500',
	floating: 'bg-white shadow-sm rounded-md flex items-center pl-2 focus-within:ring-blue-500',
}

/**
 * FilterBox provides a consistent container for filter components.
 * It handles the outer styling, icon positioning, and theme variations.
 */
export function FilterBox({ children, icon, theme = 'default', className }: FilterBoxProps) {
	return (
		<div className={ctl(`${themeStyles[theme]} ${className ?? ''}`)}>
			{icon && <div className="shrink-0 pl-2">{icon}</div>}
			<div className="flex-1 min-w-0">{children}</div>
		</div>
	)
}
